import * as type from './AccountCreationActionType';

export const setAccountCreationEmail = (email) => {
    const action = {
        type: type.SET_CREATE_ACCOUNT_EMAIL,
        email: email
    }
    return action;
}